<template>
  <v-layout class="mechanic-rents" wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('mechanic.rents.title') }}</h1>
        </v-flex>
      </v-layout>
    </v-flex>

    <div class="mechanic-rents__filters">
      <div class="mechanic-rents__search">
        <v-text-field
          v-model="searchString"
          class="search"
          autocomplete="off"
          solo
          :placeholder="$t('mechanic.rents.placeholder')"
        />
        <v-btn
          type="button"
          color="warning"
          large
          @click="filters.search = searchString"
        >
          {{ $t('common.btns.search') }}
        </v-btn>
      </div>

      <v-select
        v-model="filters.status"
        :label="$t('common.fields.status')"
        item-text="name"
        item-value="id"
        class="mechanic-rents__filters-item"
        clearable
        :items="carStatuses"
        :loading="statusesLoading"
      />
    </div>

    <v-data-table
      ref="rents-table"
      class="mechanic-rents__table"
      style="width:100%"
      :headers="headers"
      :height="tableHeight"
      :items-per-page="perPage"
      :items="list"
      :loading="loading"
      hide-default-footer
    >
      <template #item="{ item }">
        <tr>
          <td>{{ item.num }}</td>
          <td>{{ item.number }}</td>
          <td>{{ item.brand }}</td>
          <td>{{ item.model }}</td>
          <td>{{ formatAmount(item.rentDayPrice) }}</td>
          <td>{{ item.car_status_name || '—' }}</td>
          <td>
            <div class="d-flex">
              <v-btn
                v-if="item.is_accept"
                class="mr-3"
                color="green"
                elevation="0"
                small
                dark
                rounded
                :to="
                  `./accept-auto/${item.carId}?workDeskItemId=${item.workDeskItemId}`
                "
              >
                {{ $t('mechanic.accept') }}
              </v-btn>
              <v-btn
                v-if="item.is_passed"
                color="blue"
                elevation="0"
                small
                dark
                rounded
                @click="
                  () => {
                    passAutoDialog.opened = true;
                    passAutoDialog.carId = item.carId;
                  }
                "
              >
                {{ $t('mechanic.pass') }}
              </v-btn>
            </div>
          </td>
        </tr>
      </template>

      <template #footer>
        <v-divider />
        <div class="pt-1 pb-2">
          <v-pagination
            color="warning"
            :value="currentPage"
            :length="lastPage"
            dark
            circle
            @input="fetchList({ ...filters, page: $event })"
          />
        </div>
      </template>
    </v-data-table>

    <pass-auto-dialog
      v-model="passAutoDialog.opened"
      :car-id="passAutoDialog.carId"
      @updated="proccessResponse"
    />

    <v-snackbar
      v-model="snack.value"
      absolute
      bottom
      right
      :color="snack.color"
      :timeout="3000"
    >
      {{ snack.message }}
    </v-snackbar>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import formatAmount from '@/helpers/formatAmount';
import PassAutoDialog from '@/components/mechanic/PassAutoDialog.vue';
import calcTableHeight from '@/helpers/calcTableHeight';

export default {
  components: { PassAutoDialog },
  data: () => ({
    loading: false,
    statusesLoading: false,
    searchString: '',
    tableHeight: 'auto',

    filters: {
      search: '',
      status: null,
    },

    snack: {
      value: false,
      message: '',
      color: '',
    },

    passAutoDialog: {
      opened: false,
      carId: '',
    },
  }),
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler(params) {
        this.fetchList(params);
      },
    },
  },
  computed: {
    ...mapState({
      list: ({ mechanic }) => mechanic.rents.list,
      currentPage: ({ mechanic }) => mechanic.rents.currentPage,
      lastPage: ({ mechanic }) => mechanic.rents.lastPage,
      perPage: ({ mechanic }) => mechanic.rents.perPage,
      carStatuses: (state) => state['workers-board'].carStatuses,
    }),
    headers() {
      return [
        { text: this.$t('common.number'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.number'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.brand'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.model'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.price'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.status'), sortable: false },
        { text: this.$t(''), name: 'actions', sortable: false },
      ];
    },
  },
  methods: {
    formatAmount,
    async fetchList(params) {
      this.loading = true;
      await this.$store.dispatch('mechanic/fetchMechanicRents', params);
      this.loading = false;
    },
    proccessResponse({ success, error }) {
      const snack = {
        value: true,
        color: 'success',
        message: this.$t('common.saved'),
      };

      if (error) {
        snack.message = this.$t('common.errors.APIerror');
        snack.color = 'error';
      }

      if (success) {
        this.fetchList({ ...this.filters, page: this.currentPage });
      }

      this.snack = snack;
    },
  },
  async created() {
    this.statusesLoading = true;
    await this.$store.dispatch('workers-board/fetchDialogProps');
    this.statusesLoading = false;
  },
  mounted() {
    const table = this.$refs['rents-table'];
    this.tableHeight = calcTableHeight(table.$el);
  },
};
</script>

<style lang="scss">
.mechanic-rents {
  &__filters {
    display: flex;
    width: 100%;
    margin-top: 30px;

    &-item {
      max-width: 230px;
      margin-left: 30px;
    }
  }

  &__search {
    display: flex;
    max-width: 450px;
    width: 100%;

    .search {
      width: 100% !important;
    }
  }

  &__table {
    thead {
      position: sticky;
      top: 0;
      z-index: 1;
    }
  }

  .v-pagination__item,
  .v-pagination__navigation {
    box-shadow: none;
  }
}
</style>
